<template>
  <div>
    <v-text-field
      hide-details
      :label="title"
      prepend-inner-icon="mdi-square-edit-outline"
      @click="edit"
      v-model="text"
      filled
      readonly
    ></v-text-field>

    <v-dialog v-model="dialog" scrollable width="800">
      <v-card>
        <v-card-title>Edit Workflow Parameters</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-simple-table>
            <thead>
              <tr>
                <th>Parameter Name</th>
                <th>Value Source</th>
                <th>Value Name</th>
                <th style="width: 40px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in values" :key="index">
                <td>
                  <v-text-field
                    v-model="item.name"
                    filled
                    hide-details
                  ></v-text-field>
                </td>
                <td>
                  <FieldValuePickerBase
                    v-model="item.value"
                    :table="table"
                    :component="component"
                    :containers="containers"
                  />
                </td>
                <td>
                  <v-btn color="error" icon @click="deleteColumn(index)">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
              <tr v-if="values.length == 0">
                <td colspan="4" class="text-center">Please click add button</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="primary" @click="addColumn">
            <v-icon>mdi-plus</v-icon>
            <span>Add</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="save">Ok</v-btn>
          <v-btn text color="error" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FieldValuePickerBase from "../../ui/shared/FieldValuePickerBase.vue";

export default {
  name: "WorkflowParamsEditor",

  components: { FieldValuePickerBase },

  props: ["title", "value", "table", "component", "containers"],

  data() {
    return {
      dialog: false,
      values: [],
    };
  },

  computed: {
    text() {
      if (this.value) {
        var t = "";
        this.value.forEach((i) => {
          t += i.name + "=" + i.value + " ";
        });
        return t;
      }

      return null;
    },
  },

  methods: {
    addColumn() {
      this.values.push({
        name: "",
        source: "field",
        value: "",
      });
    },
    deleteColumn(index) {
      this.values.splice(index, 1);
    },
    edit() {
      this.values = [];

      if (this.value) {
        this.value.forEach((v) => {
          this.values.push(Object.assign({}, v));
        });
      }

      this.dialog = true;
    },
    save() {
      this.dialog = false;
      this.$emit("input", this.values);
    },
  },
};
</script>
